import MultiSelection from '../../../../dataViews/NextTree/plugins/MultiSelection';

export default {
  makeTreePlugin: canSelectNode =>
    new MultiSelection({ nodeIsSelectable: canSelectNode }),
};
